/**
 * Converts a progress number to a renderable string.
 * Number is converted from 0-1 to 0-100, truncated to a whole number and clamped between 0 and 100.
 * Then the number is renders as "{number}% Completed"
 * @param progress A number between 0 and 1
 */
export function displayableProgress(progress: number) {
  const validatedValue = Math.min(Math.max(Math.trunc(progress * 100), 0), 100);
  const displayValue = `${validatedValue}%`;

  return {
    validatedValue,
    displayValue,
  };
}
